<form novalidate [formGroup]="transactionForm" class="create-form layout-column-space-around-stretch">
    <div class="layout-row expando-row">
        <div style="flex: 1 1 1e-09px; box-sizing: border-box;">
            @for (field of firstFields.concat(lastFields); track field; let i = $index) {
                <div class="input-container">
                    @switch (field.field.canonical_name) {
                        @case (standardFields.location.canonical_name) {
                            <ah-asset-field-input [group]="transactionForm" [field]="field.field"
                                [required]="field.departmentField.required" [options]="field.field.picklistOptions" [autoFocus]="i === 0"
                                (change)="selectLocation($event)">
                            </ah-asset-field-input>
                        }
                        @case (standardFields.subLocation.canonical_name) {
                            <ah-asset-field-input [group]="transactionForm" [field]="field.field"
                                [required]="field.departmentField.required" [options]="(this.subLocationsForLocation | async)" [autoFocus]="i === 0">
                            </ah-asset-field-input>
                        }
                        @case (excludedFields.excluded_disposition.canonical_name) {
                            <ah-asset-field-input [group]="transactionForm" [field]="field.field"
                                [required]="field.departmentField.required" [options]="this.excludedDispositionOptions">
                            </ah-asset-field-input>
                        }
                        @default {
                            <ah-asset-field-input [group]="transactionForm" [field]="field.field" [required]="field.departmentField.required"
                                [options]="field.field.picklistOptions" [autoFocus]="i === 0" (keyup)="valueChange($event, field.field)"></ah-asset-field-input>
                        }
                    }
                    @if (field.field.canonical_name === 'cost') {
                        <mat-checkbox class="row-checkbox"
                            [checked]="sumTotalCostSelected" (change)="onSelectRowCheckbox($event)">
                            <label style="font-size:10px">SUM TOTAL COST </label>
                        </mat-checkbox>
                    }
                </div>
            }
        </div>
    </div>
    <div class="layout-row">
        <div class="flex-50">
            @if (!transactions[0].excluded) {
                <div class="flex-column">
                    <div class="default-flex">
                        <p-fileUpload #photoUpload name="photoFile[]" accept="image/*" multiple="mulitple" mode="basic" auto="true" customUpload="true" (uploadHandler)="addPhoto($event)"
                            chooseLabel="Photo"></p-fileUpload>
                    </div>
                    <div class="default-flex">
                        @for (photo of photos; track $index) {
                            <div class="flex-layout-row-space-between-stretch">
                                <div class="flex-80 ellipsis">{{photo.name}}</div>
                                <div class="default-flex">
                                    <mat-icon class="clickable" (click)="removePhoto(photo)" svgIcon="clear"></mat-icon>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
    <div>
        @for (item of savingMessage; track item) {
            <p-message [severity]="item.severity">{{item.summary}}</p-message>
        }
    </div>
    <!-- For TransactionExpandoRowComponent -->
     @if (isExpandoRow) {
         <div class="layout-row-end-none">
             <button mat-raised-button type="button" color="primary" style="height: 36px;" (click)="indexType === assetIndexTypes.Excluded ? updateTransaction() : saveNewAsset()"
                 [disabled]="transactionForm.invalid">Save</button>
         </div>
     }
    <!-- For CreateAssetFromTrxModalComponent -->
     @if(!isExpandoRow) {
        <div class="flex justify-flex-end gap-20">
            <button mat-raised-button (click)="closeDialog()">Cancel</button>
            <button mat-raised-button color="primary" (click)="saveNewAsset()" [disabled]="transactionForm.invalid">Create Asset</button>
        </div>
     }
</form>
